const USER_AVATAR_COLOURS = [
    "bg-avatar-red text-compendia-black",
    "bg-avatar-orange text-compendia-black",
    "bg-avatar-green text-compendia-black",
    "bg-avatar-charcoal text-compendia-white",
] as const;

function getUserAvatarFallback(userId: number, firstName: string, lastName: string) {
    const colourIndex =
        ((userId % USER_AVATAR_COLOURS.length) + USER_AVATAR_COLOURS.length) %
        USER_AVATAR_COLOURS.length;

    return {
        initials: `${firstName.trim().charAt(0)}${lastName.trim().charAt(0)}`.toLocaleUpperCase(),
        className: USER_AVATAR_COLOURS[colourIndex],
    };
}

export { getUserAvatarFallback };
